import React from 'react'
import { Modal, Row, Col, Select, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import PanelMedidasInfo from './PanelMedidasInfo'

/**
 * Modal para visualizar cotas guardadas (solo lectura, informativo)
 * Similar al modal de edición pero sin inputs ni botones.
 * Incluye opción para borrar la medida seleccionada.
 */
const ModalCotasGuardadas = ({
  visible,
  onClose,
  imagenCotasUrl,
  todasLasCotasGuardadas,
  cotaSeleccionadaId,
  onChangeMedidaSeleccionada,
  onBorrarMedida,
  coordenadasCotas,
  medidasCotas,
  canvasCotasRef,
  imageCotasRef,
  onCanvasClick,
  onCanvasMouseMove,
}) => {
  return (
    <Modal
      title="Medidas Guardadas"
      open={visible}
      onCancel={onClose}
      footer={
        onBorrarMedida && cotaSeleccionadaId ? (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <Button type="primary" danger icon={<DeleteOutlined />} onClick={onBorrarMedida}>
              Borrar medida
            </Button>
          </div>
        ) : null
      }
      width={1200}
      centered
    >
      {/* Selector de medidas */}
      {todasLasCotasGuardadas.length > 1 && (
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="selector-medidas" style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
            Seleccionar Medida:
          </label>
          <Select
            id="selector-medidas"
            value={cotaSeleccionadaId}
            onChange={onChangeMedidaSeleccionada}
            style={{ width: '100%' }}
            placeholder="Seleccione una medida"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          >
            {todasLasCotasGuardadas.map((cota) => {
              const nombreMedida = cota.nombre 
                ? `${cota.nombre} (Medida #${cota.id})`
                : `Medida #${cota.id}`
              
              return (
                <Select.Option key={cota.id} value={cota.id} label={nombreMedida}>
                  {nombreMedida}
                </Select.Option>
              )
            })}
          </Select>
        </div>
      )}
      
      {imagenCotasUrl && (
        <Row gutter={16}>
          {/* Columna izquierda: Imagen */}
          <Col span={14}>
            <div style={{ 
              textAlign: 'center', 
              position: 'relative', 
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              minHeight: '400px'
            }}>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  ref={imageCotasRef}
                  src={imagenCotasUrl}
                  alt="Imagen con cotas guardadas"
                  style={{ 
                    maxWidth: '100%',
                    maxHeight: '600px',
                    height: 'auto',
                    width: 'auto',
                    display: 'block',
                    objectFit: 'contain'
                  }}
                />
                <canvas
                  ref={canvasCotasRef}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    pointerEvents: 'auto',
                    cursor: 'pointer',
                  }}
                  onClick={onCanvasClick}
                  onMouseMove={onCanvasMouseMove}
                />
              </div>
            </div>
          </Col>
          
          {/* Columna derecha: Panel de medidas (solo lectura, informativo) */}
          <Col span={10}>
            <PanelMedidasInfo
              coordenadasCotas={coordenadasCotas}
              medidasCotas={medidasCotas}
            />
          </Col>
        </Row>
      )}
    </Modal>
  )
}

export default ModalCotasGuardadas
